import { render, staticRenderFns } from "./Uploading.vue?vue&type=template&id=16a0f4a0&"
import script from "./Uploading.vue?vue&type=script&lang=js&"
export * from "./Uploading.vue?vue&type=script&lang=js&"
import style0 from "./Uploading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports